import { Plan } from "../../@types/plan.types";

export const getOpenEnrollmentType = (plans: Plan[], plan_id: string): "SPECIAL" | "YEARLY" | null => {
	let openEnrollmentType: "SPECIAL" | "YEARLY" | null = null;
	for (let planIdx = 0; planIdx < plans.length; planIdx++) {
		const { _id, start_date, end_date } = plans[planIdx];
		if (_id === plan_id) {
			if (end_date !== null) {
				if (new Date(start_date) <= new Date() && new Date(end_date as string) >= new Date()) {
					openEnrollmentType = "SPECIAL";
				} else {
					openEnrollmentType = "YEARLY";
				}
			} else if (end_date === null) {
				if (new Date(start_date) <= new Date()) {
					openEnrollmentType = "SPECIAL";
				} else {
					openEnrollmentType = "YEARLY";
				}
			}

			break;
		}
	}
	// console.log("==========> openEnrollmentType ==>", openEnrollmentType);
	return openEnrollmentType;
};
